"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOutgoingBatchEventResults = exports.useOutgoingBatchStates = exports.useIncomingBatchEventResults = exports.useIncomingBatchStates = exports.useDispatchStates = exports.useDispatchMethods = exports.useComponentTypes = void 0;
const list_source_hook_1 = require("../../utils/list-source-hook");
function useComponentTypes() {
    return list_source_hook_1.useStaticListSource([
        { id: 'MAIN', name: 'Hlavní' },
        { id: 'DELIVERY_NOTE', name: 'Doručenka' },
    ]);
}
exports.useComponentTypes = useComponentTypes;
function useDispatchMethods() {
    return list_source_hook_1.useStaticListSource([
        { id: 'EMAIL', name: 'Email' },
        { id: 'DATABOX', name: 'Datová schránka' },
        { id: 'POSTAL', name: 'Poštovní adresa' },
        { id: 'POSTAL_NOTE', name: 'Poštovní adresa s doručenkou' },
        { id: 'IN_PERSON', name: 'Osobně' },
    ]);
}
exports.useDispatchMethods = useDispatchMethods;
function useDispatchStates() {
    return list_source_hook_1.useStaticListSource([
        { id: 'CREATED', name: 'Vytvořeno' },
        { id: 'SENT', name: 'Odesláno' },
        { id: 'DELIVERED', name: 'Doručeno' },
    ]);
}
exports.useDispatchStates = useDispatchStates;
function useIncomingBatchStates() {
    return list_source_hook_1.useStaticListSource([
        { id: 'RECEIVED', name: 'Přijata' },
        { id: 'PROCESSED', name: 'Zpracována' },
        { id: 'ERROR', name: 'Chyba' },
        { id: 'REPLACED', name: 'Nahrazena' },
    ]);
}
exports.useIncomingBatchStates = useIncomingBatchStates;
function useIncomingBatchEventResults() {
    return list_source_hook_1.useStaticListSource([
        { id: 'PROCESSED', name: 'Zpracována' },
        { id: 'ERROR', name: 'Chyba' },
    ]);
}
exports.useIncomingBatchEventResults = useIncomingBatchEventResults;
function useOutgoingBatchStates() {
    return list_source_hook_1.useStaticListSource([
        { id: 'ENQUEUED', name: 'Čekající' },
        { id: 'SENT', name: 'Odeslána' },
        { id: 'PROCESSED', name: 'Zpracována' },
        { id: 'ERROR', name: 'Chyba' },
        { id: 'REPLACED', name: 'Nahrazena' },
    ]);
}
exports.useOutgoingBatchStates = useOutgoingBatchStates;
function useOutgoingBatchEventResults() {
    return list_source_hook_1.useStaticListSource([
        { id: 'PROCESSED', name: 'Zpracována' },
        { id: 'ERROR', name: 'Chyba' },
    ]);
}
exports.useOutgoingBatchEventResults = useOutgoingBatchEventResults;
//# sourceMappingURL=ess-api.js.map